<template>
  <CRow>
    <CCol cols="12" md="12" lg="12">
      <b-card header-tag="header" header-bg-variant="dark">
        <template #header>
          <p class="mb-0" style="">
            <strong>{{ $store.state.table.laporanLembur }}</strong>
          </p>
        </template>
        <CRow>
          <CCol col="5">
            <b-form-group label="Periode" label-for="periode" class="my-0">
              <Multiselect
                id="periode"
                v-model="filter.periode"
                :options="listPeriodeGaji"
                :multiple="false"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="-- Pilih Periode --"
                label="namaPeriode"
                track-by="id"
                @input="hitungTanggal()"
              ></Multiselect>
            </b-form-group>
          </CCol>
          <CCol col="5">
            <b-form-group label="Bulan - tahun" label-for="bulanTahun" class="my-0">
              <date-picker id="bulanTahun" type="month" format="MMMM - YYYY" style="width: 100%" v-model="filter.bulanTahun" @input="hitungTanggal()"></date-picker>
            </b-form-group>
          </CCol>
          <CCol col="2" style="margin-bottom: 6px">
            <div class="w-100 h-100 d-flex align-items-end">
              <b-button variant="danger" style="" class="d-block w-100" v-c-tooltip.hover.click="'Reset'" @click="reset()">Reset</b-button>
            </div>
          </CCol>
          <CCol col="12" class="">
            <small class="mx-2">{{ $moment(filter.tglAwal).format("LL") }} - {{ $moment(filter.tglAkhir).format("LL") }} ( {{ filter.jmlHari }} hari)</small>
          </CCol>
          <CCol col="12" class="mt-1 mb-2"><hr /></CCol>
          <CCol col="12">
            <CDataTable :items="items" :fields="fields" responsive sorter column-filter hover show-empty :loading="loading" @update:column-filter-value="onFilter($event)">
              <template #namaTanggalPengajuanLembur-filter>
                <date-picker style="width: 100%" v-model="filter.tanggalPengajuanLembur" format="DD MMMM YYYY" required></date-picker>
              </template>
              <template #jumlahJamLembur-filter>
                <b-form-select v-model="filter.jumlahJamLembur" :options="optionsJam"></b-form-select>
              </template>
              <template #Actions="{ item }">
                <td>
                  <b-button variant="info" class="mr-1" v-c-tooltip.hover.click="'Detail Data'" v-b-modal.modal-detail @click="data = item"><CIcon name="cil-info" /></b-button>
                </td>
              </template>
            </CDataTable>
            <MyPagination :entriesaw="entriesaw" :entriesak="entriesak" :totalRows="totalRows" :currentPage="currentPage" :perPage="perPage" @changeVar="changeVar" />
          </CCol>
        </CRow>
      </b-card>
    </CCol>
    <modal-detail :data="data" @alertFromChild="triggerAlert($event)" />
  </CRow>
</template>

<script>
import modalDetail from "./modalDetail.vue";

export default {
  components: {
    modalDetail,
  },
  name: "laporanLembur",
  data() {
    return {
      data: {},
      listPeriodeGaji: [],
      items: [],

      filter: {
        tanggalPengajuanLembur: null,
        statusPengajuan: null,
        jumlahJamLembur: null,
        periode: null,
        bulanTahun: null,
        tglAwal: null,
        tglAkhir: null,
        jmlHari: "0",
      },
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      loading: false,
      optionsJam: [
        { value: null, text: "Pilih" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
        { value: "6", text: "6" },
        { value: "7", text: "7" },
        { value: "8", text: "8" },
      ],
    };
  },
  computed: {
    entriesaw() {
      return this.items.length != 0 && this.items ? this.items[0].no : 0;
    },
    entriesak() {
      return this.items.length != 0 && this.items ? this.items[this.items.length - 1].no : 0;
    },
    fields() {
      return [
        {
          key: "no",
          label: this.$store.state.table.no,
          sortDirection: "desc",
          _classes: "table-number text-center ",
          _style: "width: 1px;",
          filter: false,
          sorter: false,
        },
        {
          key: "namaKaryawan",
          label: this.$store.state.table.namaKaryawan,
          _style: "max-width: 45%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaTanggalPengajuanLembur",
          label: this.$store.state.table.namaTanggalPengajuanLembur,
          _style: "width: 20%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "jumlahJamLembur",
          label: this.$store.state.table.jumlahJamLembur,
          _style: "width: 10%;",
          sortDirection: "desc",
          _classes: "text-left",
          sorter: false,
        },
        {
          key: "namaNominalLembur",
          label: this.$store.state.table.namaNominalLembur,
          _style: "width: 20%;",
          sortDirection: "desc",
          _classes: "text-right",
          filter: false,
          sorter: false,
        },
        {
          key: "Actions",
          label: this.$store.state.table.Actions,
          _style: "width: 5%;",
          _classes: "table-option-2 text-center",
          filter: false,
          sorter: false,
        },
      ];
    },
  },
  async mounted() {
    if (this.$store.state.role_aktif.kodeRole == "super") {
      this.fields.splice(1, 0, {
        key: "namaMitra",
        label: "Mitra",
        _style: "width: 10%;",
        sortDirection: "desc",
        class: "text-left",
        sorter: false,
      });
    }
    // this.getDatas();
    await this.getPeriodeGaji();
    this.reset();
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    perPage: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.tanggalPengajuanLembur"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.statusPengajuan"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    "filter.jumlahJamLembur"(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getDatas();
      }
    },
    // 'filter.periode'(newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     this.hitungTanggal();
    //   }
    // },
    "filter.bulanTahun"(newVal, oldVal) {
      if (newVal == null) {
        this.reset();
      } else if (newVal != oldVal) {
        this.hitungTanggal();
      }
    },
  },
  methods: {
    onFilter(x) {
      const vm = this;
      vm.filter = { ...vm.filter, ...x };
      vm.currentPage = 1;
      vm.getDatas();
    },
    async hitungTanggal() {
      const vm = this;
      if (!vm.filter.periode) vm.filter.periode = vm.listPeriodeGaji[0];
      const periode = vm.filter.periode;
      const monthYear = vm.$moment(vm.filter.bulanTahun).format("MM-YYYY");
      //set tanggal terakhir bulan
      const tanggalTerakhirBulan = vm.$moment(`${monthYear}`, "MM-YYYY").endOf("month").format("D");
      periode.xtanggalGajian = periode.tanggalGajian == -1 ? tanggalTerakhirBulan : periode.tanggalGajian;
      periode.xtanggalAwal = periode.tanggalAwal == -1 ? tanggalTerakhirBulan : periode.tanggalAwal;
      periode.xtanggalAkhir = periode.tanggalAkhir == -1 ? tanggalTerakhirBulan : periode.tanggalAkhir;
      //set tanggal default
      vm.filter.tglAwal = vm.$moment(`${periode.xtanggalAwal}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      vm.filter.tglAkhir = vm.$moment(`${periode.xtanggalAkhir}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      //jika tanggal awal adalah bulan sebelumnya (awal - akhir = 30 - 10)
      if (periode.xtanggalAwal > periode.xtanggalAkhir) {
        let tanggal = vm.$moment(`${monthYear}`, "MM-YYYY").subtract(1, "month");
        //jika xtanggalAwal adalah tanggal terakhir bulan
        let awal = periode.xtanggalAwal;
        /*
          jika tanggal awal = -1 (tanggal terakhir bulan) atau
          jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal akhir dalam bulan)
        */
        if (periode.tanggalAwal == -1 || periode.xtanggalAwal > vm.$moment(tanggal).endOf("month").format("D")) {
          awal = vm.$moment(tanggal).endOf("month").format("D");
        }
        vm.filter.tglAwal = vm.$moment(`${awal}-${tanggal.format("MM")}-${tanggal.format("YYYY")}`, "D-MM-YYYY").format("YYYY-MM-DD");
      } else {
        //jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal awal dalam bulan)
        if (periode.xtanggalAwal > tanggalTerakhirBulan) {
          vm.filter.tglAwal = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
        }
      }
      //jika tanggal akhir melebihi tanggal dalam bulan (bulan februari tetapi tanggal akhir = 30, maka tanggal akhir ikut 28 / tanggal akhir dalam bulan)
      if (periode.xtanggalAkhir > tanggalTerakhirBulan) {
        vm.filter.tglAkhir = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      }
      vm.filter.jmlHari = vm.$moment(vm.filter.tglAkhir).diff(vm.$moment(vm.filter.tglAwal), "Days") + 1;
      vm.getDatas();
    },
    async getDatas() {
      const vm = this;
      vm.loading = true;
      let listPengajuanLembur = await vm.$axios.post("/pengajuanLembur/listPerHalaman", {
        ...vm.filter,
        tanggalPengajuanLembur: vm.filter.tanggalPengajuanLembur ? vm.$moment(vm.filter.tanggalPengajuanLembur).format("YYYY-MM-DD") : null,
        halaman: vm.currentPage - 1,
        jumlah: vm.perPage,
        statusPengajuan: "1",
      });
      // console.log("listPengajuanLembur", listPengajuanLembur);
      vm.items =
        listPengajuanLembur.data.status == 200
          ? listPengajuanLembur.data.data.map((x, idx) => {
              return {
                ...x,
                //view
                no: (vm.currentPage - 1) * vm.perPage + idx + 1,
                id: x.pengajuanLemburId,
                namaMitra: x.namaMitra || " - ",
                namaTanggalPengajuanLembur: vm.$moment(x.tanggalPengajuanLembur).format("LL"),
                namaNominalLembur: vm.toNumeric(x.nominalLembur, "idr"),
              };
            })
          : [];
      vm.totalRows = parseInt(listPengajuanLembur.data.count);
      vm.loading = false;
    },
    async getPeriodeGaji() {
      let vm = this;
      let listPeriodeGaji = await vm.$axios.post("periodeGajiMitra/list");
      // console.log('listPeriodeGaji : ', listPeriodeGaji)
      vm.listPeriodeGaji =
        listPeriodeGaji.data.status == 200
          ? listPeriodeGaji.data.data.map((x) => {
              x.namaTanggalGajian = x.tanggalGajian == -1 ? "akhir bulan" : "Tanggal " + x.tanggalGajian;
              x.namaTanggalAwal = x.tanggalAwal == -1 ? "akhir bulan" : x.tanggalAwal;
              x.namaTanggalAkhir = x.tanggalAkhir == -1 ? "akhir bulan" : x.tanggalAkhir;
              return {
                ...x,
                namaPeriode: `Gajian ${x.namaTanggalGajian} (Kerja ${x.namaTanggalAwal} - ${x.namaTanggalAkhir})${x.isBpjs ? ", BPJS" : ""}`,
              };
            })
          : [];
    },
    reset() {
      const vm = this;
      const month = vm.$moment().format("MM");
      const year = vm.$moment().format("YYYY");
      vm.filter.bulanTahun = new Date(vm.$moment(`01-${month}-${year}`, "DD-MM-YYYY"));
      vm.filter.periode = vm.listPeriodeGaji[0];
      this.hitungTanggal();
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
      vm.getDatas();
    },
    changeVar({ name, data }) {
      this[name] = data;
    },
    toNumeric(number, type) {
      let data = {};
      if (type == "no-idr") {
        return new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR" }).format(number).slice(3); //10.000,00
      } else {
        if (type == "idr") data = { style: "currency", currency: "IDR" }; //Rp 10.000,00
        return new Intl.NumberFormat("id-ID", data).format(number); //10.000
      }
    },
  },
};
</script>
